import { modalShelfDiagramStore } from '@/store'
import { modalShelfDiagramInterface } from '@/store/ModalShelfDiagramStore'

export class ModalShelfDiagramService {
  public open(params: modalShelfDiagramInterface) {
    modalShelfDiagramStore.open(params)
  }

  public close() {
    modalShelfDiagramStore.close()
  }
}
